import { memo } from "react";
import { BzModal, BzModalBody, BzModalHeader, BzButton, BzModalFooter } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals";
import { getAppInfoData } from "../../utils/global_functions";
import { APP_INFO_PARAMS } from "../../utils/global_variables";
import ViewBranches from "./ViewBranches";



const ContactUs = () => {

    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);
    const objAppInfo = useSelector(state => state.appInfo.appInfo);

    const contactInfo = getAppInfoData(APP_INFO_PARAMS?.APP_CONTACTUS, objAppInfo);

    const arrUniqueContacInfo = [];

    for (const obj of contactInfo) {
        // Hari K :14-09-2023 Check if an object with the same name and value doesn't already exist
        if (!arrUniqueContacInfo.some(uniqueObj => uniqueObj.name === obj.name && uniqueObj.value === obj.value)) {
            arrUniqueContacInfo.push(obj);
        }
    }

    const handleClose = () => {
        dispatch(handleModal([{ "CONTACT_US": false }]));
    };

    const handleViewBranchesClick = () => {
        dispatch(handleModal([{ "VIEW_BRANCHES_MODAL": true }]));
    };

    return (
        <>
            <BzModal show={modals['CONTACT_US']} onHide={handleClose} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Contact Us</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {arrUniqueContacInfo?.length && arrUniqueContacInfo?.map((each, i) => (
                            <Row key={i} className='g-0 pb-3'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className={each?.type === 'tel' ? 'icon-16 icon-phone icon-dark me-2' : each?.type === "email" ? 'icon-16 icon-email icon-dark me-2' : null}></div>
                                    <div className='font-regular font-size4 color-text'>{each?.name === "Email your Query" ? "Email" : each?.name}: <a className='color-text font-medium focus' href={`${each?.type === "tel" ? `tel:${each.value}` : `mailto:${each.value}`}`}>{each?.value}</a></div>
                                </Col>
                            </Row>
                        ))}
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton className='btn btn-md btn-primary' onClick={() => handleViewBranchesClick()}>View Branches</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <ViewBranches />
        </>
    );
};

export default memo(ContactUs);